<template>
    <b-row>
      <b-col sm="12">
        <div>
          <b-btn v-b-toggle.collapse1 variant="primary">Filters</b-btn>
          <b-btn @click="resetFilters">Clear Filters</b-btn>

          <b-collapse id="collapse1" class="mt-2">
            <b-card>
              <b-row>
                <b-col sm="2" v-for="field in otherFields" :key="field.name">
                  <b-form-group
                    :label="field.label" :label-for="field.name"
                  >
                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                      :id="field.name"
                      v-model="filters[field.name]"
                      :options="getOtherFilterOptions(field)"
                      :style="{ width: '150px' }"
                    >
                      <option slot="first" :value="null">Choose...</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group
                    label="Service Called?"
                    label-for="service-called"
                  >
                    <treeselect
                      :value="yesNoFieldsFilter"
                      @select="handleSelect"
                      @deselect="handleDeselect"
                      :multiple="true"
                      :options="yesOrNoFields"
                    />
                    <!--b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                      :id="field.name"
                      v-model="filters[field.name]"
                      :options="getFilterOptions(field)"
                      :style="{ width: '150px' }"
                    >
                      <option slot="first" :value="null">Choose...</option>
                    </b-form-select-->
                  </b-form-group>
                </b-col>
                <b-col v-if="userGroup.id" sm="2">
                  <b-form-group
                    label="Owning Organization"
                    label-for="organizationOwner"
                  >
                    <treeselect
                      :value="filters.organizationOwner"
                      @select="handleOrgOwnerSelect"
                      @deselect="handleOrgOwnerDeselect"
                      :multiple="true"
                      :options="organizationsByGroup"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-button
                v-on:click.prevent="updateSearchResults"
                type="submit"
                variant="primary"
                class="px-4"
              >
                Update Results
              </b-button>
            </b-card>
          </b-collapse>
        </div>
      </b-col>
    </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import userStateMixin from '@/mixins/userState.js'

const defaultFilters = {
  b_confirmed: null,
  p_cps_called: null,
  p_le_called: null,
  cseit_conclusion: null,
  ls_conclusion: null,
  p_csey_advocate_called: null,
  organizationOwner: [],
  inactive: null
}

export default {
  name: 'dashboardFilters',
  components: {
    Treeselect
  },
  mixins: [userStateMixin],
  data: function () {
    return {
      filters: {
        ...defaultFilters
      },
      filteredOrgNames: []
    }
  },
  computed: {
    ...mapGetters({
      'personYesNoFields': 'getPersonYesNoFields',
      'personOtherFields': 'getPersonOtherFields',
      'personOtherFieldsLA': 'getPersonOtherFieldsLA',
      'userCurrentContext': 'userCurrentContext',
      'userGroupDetails': 'getViewgroup'
    }),
    yesNoFieldsFilter () {
      return Object.keys(this.personYesNoFields)
        .filter(key => this.filters.hasOwnProperty(key))
    },
    yesOrNoFields () {
      return this.personYesNoFields.map((field) => {
          return {
            id: field.name,
            label: field.label
          }
        })
    },
    otherFields () {
      return this.isUserInLA ? this.personOtherFieldsLA : this.personOtherFields
    },
    organizationsByGroup () {
      console.log('userGroupDetails', this.userGroupDetails.memberOrgs)
      return (this.userGroupDetails && this.userGroupDetails.memberOrgs)
        ? this.userGroupDetails.memberOrgs.map((org) => ({
          id: org.id,
          label: org.title
        }))
        : []
    },
    userGroup () {
      return _.get(this.userCurrentContext, 'group')
    }
  },
  watch: {
    userGroup (newValue) {
      if (newValue && newValue.id) {
        this.getUserGroupDetails()
      }
    }
  },
  methods: {
    getUserGroupDetails () {
      this.$store.dispatch('getGroupView', {
        id: this.userGroup.id
      })
    },

    handleSelect (val) {
      this.filters[val.id] = 'Yes'
    },

    handleDeselect (val) {
      this.filters[val.id] = null
    },

    handleOrgOwnerSelect (val) {
      this.filters['organizationOwner'].push(val.id)
    },

    handleOrgOwnerDeselect (val) {
      const index = _.findIndex(this.filters['organizationOwner'], (v) => v === val.id)
      this.filters['organizationOwner'].splice(index, 1)
    },

    getFilterOptions (field) {
      let yesNoDefaults = { 'Yes': 'Yes', 'No': 'No' }
      if (field.yesNo) {
        // Custom yes/no labels live in person-form-field-definitions.json
        if (field.yesNoLabels) {
          return {
            'Yes': field.yesNoLabels.yes,
            'No': field.yesNoLabels.no
          }
        }
        return yesNoDefaults
      }
    },
    getOtherFilterOptions (field) {
      if (field.other) {
        return field.otherLabels
      }
    },
    resetFilters () {
      this.filters = { ...defaultFilters }
      this.filters['organizationOwner'] = []
      this.$emit('clear-filter')
    },
    getAllSearchParams () {
      let filters = this.filters
      filters = _.pickBy(filters, _.identity)

      let params = {
        populate: 'organization',
        sort: 'createdAt DESC'
      }

      params = {
        filters: {
          ...params,
          ...filters
        }
      }

      return params
    },
    updateSearchResults () {
      const params = this.getAllSearchParams()
      this.$emit('set-filter', params)
    }
  },
  created () {
    const query = this.$router.currentRoute.query

    // We have filters, so we'll kick off the dispatch calls
    if (!_.isEmpty(query)) {
      for (const filter in this.filters) {
        if (query[filter]) {
          this.filters[filter] = query[filter]
        }
      }

      this.updateSearchResults()
    }

    if (this.userGroup) {
      this.getUserGroupDetails()
    }
  }
}
</script>

<style src="@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/t1/DashboardFilters.vue